import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '/api';
const api  = axios.create({ baseURL: BASE });

export const getStatus         = ()      => api.get('/status');
export const getExperiments    = ()      => api.get('/experiments');
export const getExperiment     = (id)    => api.get(`/experiments/${id}`);
export const getExperimentData = (id)    => api.get(`/experiments/${id}/data`);
export const createExperiment  = (body)  => api.post('/experiments', body);
export const startExperiment   = (body)  => api.post('/experiment/start', body);
